import { defineMessages } from 'react-intl';

const messages = defineMessages({
  spacing: {
    id: 'Spacing',
    defaultMessage: 'Spacing',
  },
});

export const schemaSpacing = ({ intl }) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.spacing),
        fields: ['spacing'],
      },
    ],
    properties: {
      spacing: {
        title: intl.formatMessage(messages.spacing),
        description: (
          <>
            Leia mais sobre os espaçamentos do{' '}
            <a
              href="https://www.gov.br/ds/fundamentos-visuais/espacamento"
              target="_blank"
              rel="noreferrer"
            >
              Design System do Gov.br
            </a>
          </>
        ),
        noValueOption: false,
        default: '3',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['1', 'half (4px)'],
          ['2', 'base (8px)'],
          ['3', '2x (16px)'],
          ['4', '3x (24px)'],
          ['5', '4x (32px)'],
          ['6', '5x (40px)'],
        ],
      },
    },
  };
};

export default schemaSpacing;
